export default __webpack_public_path__ + "static/assets/med_pill_square_in_L0_solid_l_01_f.5306e563.png";